import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const PresetItemRowStyled = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr auto',
  gap: '16px',
  alignItems: 'flex-start',
  padding: '16px',
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  '& .MuiInputBase-root': {
    backgroundColor: '#fff',
  },
}));

export const PresetItemDescriptionRowStyled = styled(Box)({
  gridColumn: '1 / 4',
});
